export const ITR_updateFlowTypeEnumReducer = {
  ITR_updateFlowTypeEnum: (state, action) => {
    state.flowTypeEnum = action.payload;
  },
};
